// TO DO MT-527 - add all characters in FE and BE
// export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^~_.£()+\
// -=\[\]{};':"\\|,.<>\/?])[A-Za-z\d@$!%*?&#^~_.£()+\-=\[\]{};':"\\|,.<>\/?]{8,30}$/;
// Start - Replaced - bug fix MT-375
export const SPECIAL_CHARACTERS_REGEX = /[!@#$%^&*(),.?":{}|<>]/;
export const PASSWORD_REGEX_MIN_8_WITH_NUMBER = /^(?=.*\d).{8,}$/;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^~_.£()+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z\d@$!%*?&#^~_.£()+\-=\[\]{};':"\\|,.<>\/?]{8,30}$/;
// END - Replaced - bug fix MT-375
export const EMAIL_REGEX = /^[\w-+\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const ANNONYMOUS_NAME = /\^([^]*?)\^/g;
